import React, { Component } from "react"
import Radium from "radium"
import { connect } from "react-redux"
import { GridSize } from "@material-ui/core/Grid"
import { RouteComponentProps } from "react-router"
import { get } from "lodash"
import Icon from "@mdi/react"
import {
  mdiArrowRightBold,
  mdiFile,
  mdiPlaylistPlus,
  mdiFilePlus,
  mdiCircleMultiple,
  mdiCircleMultipleOutline,
} from "@mdi/js"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

import { ColorPalette } from "../../config/colors"
import { ActionType } from "../../store/actions/actions"
import { docCategories, docsSectionConfig } from "../../config"
import { DocServiceFactory, DocsService } from "../../services/docService"
import NavBar from "../../components/Navigation/NavBar"
import SectionHeader from "../../components/Headings/SectionHeaderPrimary"
import LoadingModal from "../../components/Modals/LoadingModal"
import DownloadQueueModal from "../../components/Modals/DownloadQueueModal"
import AlertModalOneButton from "../../components/Modals/AlertModalOneButton"
import DataTable from "../../components/Tables/DataTable/DataTable"
import { PeopleFlowCombinedReducer } from "../../store"
import { Profile, ProfilePk } from "../../models"
import { SessionService, ProfileService, TableService } from "../../services"
import { toUpperCaseCustom } from "../../utils"
import { Toolbar } from "../../components/GeneralUI/Toolbar"
import { DocSelection } from "../../components/DocExport/DocSelection"
import { DateRangeSelections, DateRangesModal } from "../../components/Modals/DateRanges/DateRangesModal"
import { AssociationSettingsRepository, ProfileRepository, UsersRepository } from "../../repositories"
import {
  AsyncTaskDocExport,
  NavMenuAccess,
  DocViewerConfig,
  UiCategoryEnum,
  DocsByProfilePk,
  DocTableColumnConfig,
} from "../../types"
import { ISectionConfigItem } from "../../interfaces"
import { Table } from "simplygrow-ui"
dayjs.extend(relativeTime)

const tableHeight = window.innerHeight * 0.75

export type DocDownloadQueueItem = {
  queueId: string
  status: string
  label: string
  fileLocation: { key: string }
}
interface DocExportProps extends RouteComponentProps {
  associationRepo: AssociationSettingsRepository
  userRepo: UsersRepository
  currentScreen: UiCategoryEnum
  currentSection: UiCategoryEnum
  selectedAssociation: string
  idPassport: string
  password: string
  selectedCohort: string
  profileRepo: ProfileRepository
  searchString: string[]
  asyncTaskQueueDocExport: AsyncTaskDocExport[]
  itemsBeingGenerated: DocDownloadQueueItem[]
  navMenuAccess: NavMenuAccess

  updateState: (data: any) => void
}
interface DocExportState {
  loadingModalOpen: boolean
  warningModalOpen: boolean
  docDateRangesModalOpen: boolean
  downloadQueueModalOpen: boolean
  isUpdatingDocExportQueue: boolean
  loadingModalMessage: string
  loadingModalAuxMessage: string
  warningModalHeader: string
  warningModalMessage: string
  tableWidth: GridSize
  sectionConfig: ISectionConfigItem[]
  selectedCategoryName: string
  docTableConfig: DocViewerConfig
  step: string
  selectAllEnabled: boolean
  selectedFolders: string[]
  profileData: any[]
  downloading: boolean
  processed: string[]
  authorisedPks: string[]
  searchString: string
  customProfileFilterConfig: { key: string; label: string }[]
  selectedDateRange: Record<string, any>
  dateSelectionRangeExceeded: boolean
  dateSelectAdditionalInfo: React.ReactNode
  itemsDownloading: string[]
  selectedProfilePks: ProfilePk[]
}

const profileService = new ProfileService()
const sessionService = new SessionService()
const tableService = new TableService()
const docsService = DocServiceFactory.create()
class DocExports extends Component<DocExportProps, DocExportState> {
  constructor(props: DocExportProps) {
    super(props)
  }

  initialModalState = {
    loadingModalOpen: false,
    warningModalOpen: false,
    docDateRangesModalOpen: false,
    downloadQueueModalOpen: false,
  }

  state: DocExportState = {
    ...this.initialModalState,
    loadingModalMessage: "",
    loadingModalAuxMessage: "",
    warningModalHeader: "",
    warningModalMessage: "",
    tableWidth: 10,
    sectionConfig: [],
    selectedCategoryName: "TIME_SENSITIVE_DOCS",
    docTableConfig: {},
    processed: [],
    profileData: [],
    step: "docSelection",
    searchString: "",
    isUpdatingDocExportQueue: false,
    selectAllEnabled: false,
    downloading: false,
    selectedFolders: [],
    authorisedPks: [],
    customProfileFilterConfig: [],
    selectedDateRange: {},
    dateSelectionRangeExceeded: false,
    dateSelectAdditionalInfo: null,
    itemsDownloading: [],
    selectedProfilePks: [],
  }

  componentDidMount() {
    this.props.updateState({
      currentSection: UiCategoryEnum.TRANSFER,
      currentScreen: UiCategoryEnum.EXPORT_DOCS,
    })
    const { associationRepo, selectedAssociation } = this.props
    const customProfileFilterConfig = associationRepo.getProfileFilterConfig(selectedAssociation)
    const sectionConfig = this.generateSectionConfig()
    const selectedCategoryName = "TIME_SENSITIVE_DOCS"
    this.setState({ selectedCategoryName, sectionConfig, customProfileFilterConfig }, () => {
      this.initialiseDocumentTable()
      this.updateQueueData(false)
    })
    this.clearItemsDownloading()
  }

  clearItemsDownloading() {
    this.setState({ itemsDownloading: [] })
  }

  closeModals() {
    this.setState({ ...this.initialModalState }, this.forceUpdate)
  }

  generateSectionConfig = (): ISectionConfigItem[] => {
    let sectionConfig = [
      { sectionLabel: "TIME SENSITIVE DOCS", sectionName: "TIME_SENSITIVE_DOCS" },
      ...docsSectionConfig,
    ]
    return sectionConfig
  }

  initialiseDocumentTable(): void {
    function generateDocTableConfig(
      selectedAssociation: string,
      associationRepo: AssociationSettingsRepository,
      docsService: DocsService,
    ): DocViewerConfig {
      let docTableConfig: DocViewerConfig = { TIME_SENSITIVE_DOCS: {} }
      const docConfig = associationRepo.getDocConfig(selectedAssociation)
      const processConfigEntity = associationRepo.getProcessConfigEntity(selectedAssociation)
      const allPreRequisites = processConfigEntity.getAllPreRequisiteDocNames()
      allPreRequisites.forEach((competency: string) => (docTableConfig.TIME_SENSITIVE_DOCS[competency] = []))

      let docNameCategoryMap: Record<string, string> = {}
      Object.values(docCategories).forEach((docCategory: any) => {
        docTableConfig[docCategory] = {}
        const categoryDocNames = docsService.extractDocGroup(docConfig, docCategory)
        categoryDocNames.forEach((categoryDocName: string) => (docNameCategoryMap[categoryDocName] = docCategory))
      })
      Object.keys(docNameCategoryMap).forEach((docName) => (docTableConfig[docNameCategoryMap[docName]][docName] = []))
      return docTableConfig
    }

    const { selectedAssociation, associationRepo } = this.props
    let docTableConfig = generateDocTableConfig(selectedAssociation, associationRepo, docsService)
    this.setState({ docTableConfig })
  }

  async docToolbarHandler(buttonId: string): Promise<void> {
    try {
      let { selectAllEnabled, selectedFolders, docTableConfig } = this.state

      switch (buttonId) {
        case "selectAll":
          if (selectAllEnabled) {
            selectedFolders = []
          } else {
            Object.keys(docTableConfig).forEach(
              (category) => (selectedFolders = [...selectedFolders, ...Object.keys(docTableConfig[category])]),
            )
          }
          this.setState({
            selectAllEnabled: !selectAllEnabled,
            selectedFolders,
          })
          break
      }
    } catch (error) {
      this.displayWarning(error)
    }
  }

  async loadProfileData() {
    try {
      const loadingModalMessage = "Fetching missing profiles..."
      this.setState({
        ...this.initialModalState,
        loadingModalOpen: true,
        loadingModalMessage,
        loadingModalAuxMessage: "",
      })
      const { associationRepo, profileRepo, idPassport, password, selectedAssociation, selectedCohort } = this.props
      console.log("Start")
      await profileService.downloadAssociationProfiles(
        false,
        sessionService,
        associationRepo,
        profileRepo,
        { username: idPassport, password },
        selectedAssociation,
        selectedCohort,
        (progress: string) =>
          this.setState({
            ...this.initialModalState,
            loadingModalOpen: true,
            loadingModalMessage,
            loadingModalAuxMessage: progress,
          }),
      )
      console.log("End")
      const allProfiles = profileRepo.getAllProfileEntities()
      const profileData = this.prepareProfileDataForDisplay(allProfiles)
      this.setState({ ...this.initialModalState, profileData })
    } catch (error: any) {
      this.displayWarning(error)
    }
  }

  prepareProfileDataForDisplay(allProfiles: Record<ProfilePk, Profile> | undefined): Record<string, any>[] {
    if (allProfiles === undefined) {
      return []
    }
    const { selectedAssociation } = this.props
    const { selectedDateRange, selectedFolders, customProfileFilterConfig } = this.state
    let profileData: Record<string, any>[] = []
    const profiles = Object.values(allProfiles)
    profiles.forEach((profile: Profile) => {
      const generalData = profile.getGeneralData() ? profile.getGeneralData() : { employmentStatus: "CANDIDATE" }
      const startTimestamp = selectedDateRange.capturedDateRange.startDate.getTime()
      const endTimestamp = selectedDateRange.capturedDateRange.endDate.getTime()
      let fileNames = profile.getDocFileNameStrings(selectedAssociation, startTimestamp, endTimestamp)
      let numberOfDocs = fileNames.length
      if (numberOfDocs === 0) {
        return
      }
      fileNames = fileNames.filter((docName: string) => this.containsFolderName(selectedFolders, docName))
      numberOfDocs = fileNames.length
      if (numberOfDocs === 0) {
        return
      }
      const personalInfo = profile.getPersonalInfo()
      let { name, surname, idPassport } = personalInfo
      let returnData: Record<string, any> = {
        id: profile.getPk(),
        name,
        surname,
        idPassport,
        employmentStatus: generalData.employmentStatus,
        numberOfDocs,
        docs: fileNames,
      }
      customProfileFilterConfig.forEach(({ key, label }) => (returnData[key] = get(generalData, key, "")))
      profileData.push(returnData)
    })
    return profileData
  }

  generateDocTableConfig(): DocViewerConfig {
    let docTableConfig: DocViewerConfig = { TIME_SENSITIVE_DOCS: {} }
    const { selectedAssociation, associationRepo } = this.props
    const docConfig = associationRepo.getDocConfig(selectedAssociation)
    const processConfigEntity = associationRepo.getProcessConfigEntity(selectedAssociation)
    const allPreRequisites = processConfigEntity.getAllPreRequisiteDocNames()
    allPreRequisites.forEach((docName: string) => (docTableConfig.TIME_SENSITIVE_DOCS[docName] = []))

    let docNameCategoryMap: Record<string, string> = {}
    Object.values(docCategories).forEach((docCategory: any) => {
      docTableConfig[docCategory] = {}
      const categoryDocNames = docsService.extractDocGroup(docConfig, docCategory)
      categoryDocNames.forEach((categoryDocName: string) => (docNameCategoryMap[categoryDocName] = docCategory))
    })
    Object.keys(docNameCategoryMap).forEach((docName) => (docTableConfig[docNameCategoryMap[docName]][docName] = []))
    return docTableConfig
  }

  loadSection(selectedCategoryName: string) {
    this.setState({ selectedCategoryName } as DocExportState)
  }

  folderSelectionHandler(selectedFolder: string) {
    let { selectedFolders = [] } = this.state
    if (selectedFolders.includes(selectedFolder)) {
      selectedFolders = selectedFolders.filter((folder) => folder !== selectedFolder)
    } else {
      selectedFolders.push(selectedFolder)
    }
    this.setState({ selectedFolders })
  }

  onSelectAllDocs(selectAllState: boolean) {
    let selectedFolders = [] as string[]
    if (selectAllState) {
      Object.keys(this.state.docTableConfig).forEach((docCategory) => {
        Object.keys(this.state.docTableConfig[docCategory]).forEach((folder) => selectedFolders.push(folder))
      })
    }
    this.setState({ selectedFolders })
  }

  searchHandler(event: React.ChangeEvent<{ value: string }>) {
    this.setState({ searchString: event.target.value })
  }

  containsFolderName(selectedFolders: string[], fileName: string) {
    fileName = toUpperCaseCustom(fileName)
    const found = selectedFolders.find((folder) => {
      return fileName.includes(toUpperCaseCustom(`___${folder}`))
    })
    return !!found
  }

  generateDocs = async () => {
    try {
      function generateDocBatches(allTargetDocs: DocsByProfilePk) {
        const BATCH_SIZE = 50
        let counter = 0
        let batchCounter = 0
        const docBatches = [] as DocsByProfilePk[]
        docBatches[batchCounter] = {}
        Object.keys(allTargetDocs).forEach((profilePk) => {
          docBatches[batchCounter][profilePk] = allTargetDocs[profilePk]
          counter += allTargetDocs[profilePk].length
          if (counter > BATCH_SIZE) {
            batchCounter++
            docBatches[batchCounter] = {}
            counter = 0
          }
        })
        return docBatches
      }
      async function createAsyncTasks(
        docBatches: DocsByProfilePk[],
        docsService: DocsService,
        userRepo: UsersRepository,
        token: string,
      ) {
        docBatches = [...docBatches].filter((docBatch) => Object.keys(docBatch).length)
        let asyncTasks = [] as AsyncTaskDocExport[]
        const user = userRepo.getCurrentUserEntity()
        const { name, surname } = user.getPersonalUserInfo()
        for (let i = 0; i < docBatches.length; i++) {
          const docBatch = docBatches[i]
          const asyncTask = await docsService.triggerDocBatchGeneration(
            docBatch,
            selectedAssociation,
            docsService.getDownloadBatchLabel(docBatches.length - i, name, surname),
            token,
          )
          asyncTasks.unshift(asyncTask)
        }

        return asyncTasks
      }

      this.setState({
        ...this.initialModalState,
        loadingModalOpen: true,
        loadingModalMessage: "Triggering document generation...",
        loadingModalAuxMessage: "",
      })
      const { selectedProfilePks } = this.state
      const { idPassport, password, selectedAssociation, userRepo, itemsBeingGenerated } = this.props

      let targetDocs = {} as DocsByProfilePk
      const { profileData } = this.state
      profileData.forEach((renderItem) => {
        if (!selectedProfilePks.includes(renderItem.id)) {
          return
        }
        targetDocs[renderItem.id] = renderItem.docs
      })
      const docBatches = generateDocBatches(targetDocs)
      const token = await SessionService.prepareAuthTokens(idPassport, password)
      const asyncTasks = await createAsyncTasks(docBatches, docsService, userRepo, token)
      if (!asyncTasks.length) {
        throw { code: "NoDocs" }
      }
      this.props.updateState({
        itemsBeingGenerated: [...itemsBeingGenerated, ...DocsService.asyncTasksToDownloadQueueItems(asyncTasks)],
      })
      this.updateQueueData(true)
    } catch (error) {
      console.error("error: ", error)
      this.displayWarning(error)
    }
  }

  async downloadFile(filePath: string, queueId: string): Promise<any> {
    try {
      const { idPassport, password, selectedAssociation } = this.props
      const itemsDownloading = this.state.itemsDownloading || []
      if (itemsDownloading.length && !itemsDownloading.includes(queueId)) {
        throw { code: "DownloadInProgress" }
      }
      let newItemsDownloading = [...new Set([...itemsDownloading, queueId])]
      this.setState({ itemsDownloading: newItemsDownloading })
      await docsService.downloadDocBatch(filePath)
      newItemsDownloading = newItemsDownloading.filter((existingQueueId) => existingQueueId !== queueId)
      this.setState({ itemsDownloading: newItemsDownloading })
      const token = await SessionService.prepareAuthTokens(idPassport, password)
      const asyncTaskQueueDocExport = await docsService.clearDownloadQueue(selectedAssociation, queueId, token)
      this.props.updateState({ asyncTaskQueueDocExport })
      this.forceUpdate()
    } catch (error) {
      this.displayWarning(error)
    }
  }

  async updateQueueData(showModal?: boolean) {
    function filterItemsBeingGenerated(
      asyncTaskQueueDocExport: AsyncTaskDocExport[] = [],
      itemsBeingGenerated: DocDownloadQueueItem[] = [],
    ) {
      const queueIds = [...asyncTaskQueueDocExport].map((item) => item.sk)
      itemsBeingGenerated = itemsBeingGenerated.filter(({ queueId }) => !queueIds.includes(queueId))
      return itemsBeingGenerated
    }
    if (showModal) {
      this.setState({ ...this.initialModalState, downloadQueueModalOpen: true, isUpdatingDocExportQueue: true })
    }
    let { idPassport, password, selectedAssociation, itemsBeingGenerated } = this.props
    const token = await SessionService.prepareAuthTokens(idPassport, password)
    const asyncTaskQueueDocExport = await docsService.fetchDocDownloadQueue(selectedAssociation, token)
    itemsBeingGenerated = filterItemsBeingGenerated(asyncTaskQueueDocExport, itemsBeingGenerated)

    this.props.updateState({ asyncTaskQueueDocExport, itemsBeingGenerated })
    this.setState({ isUpdatingDocExportQueue: false })
  }

  generateToolbarConfig = () => {
    const { step } = this.state
    if (step === "docSelection") {
      return [
        {
          key: "selectAll",
          label: "Select",
          iconComponent: (
            <div style={{ marginRight: 15, marginTop: 1 }}>
              <Icon size={0.8} path={mdiFile} color={ColorPalette.CARD_WHITE} />
            </div>
          ),
          sizeFactor: 1,
        },
        {
          key: "next",
          label: "Next",
          iconComponent: (
            <div style={{ marginRight: 15, marginTop: 1 }}>
              <Icon size={1} path={mdiArrowRightBold} color={ColorPalette.CARD_WHITE} />
            </div>
          ),
          sizeFactor: 1,
        },
      ]
    } else {
      return [
        { key: "idPassport", label: "ID / Passport", sizeFactor: 1, iconComponent: <div /> },
        { key: "name", label: "Name", sizeFactor: 1, iconComponent: <div /> },
        { key: "surname", label: "Surname", sizeFactor: 1, iconComponent: <div /> },
        { key: "employmentStatus", label: "Status", sizeFactor: 1, iconComponent: <div /> },
        { key: "numberOfDocs", label: "Docs in filter range", sizeFactor: 1, iconComponent: <div /> },
      ]
    }
  }

  handleDateRangeSave = (dateRangeSelections: DateRangeSelections, dataKey: string) => {
    if (this.state.dateSelectionRangeExceeded) {
      this.displayWarning({ code: "DateRangeExceed" })
      return
    }
    const selectedDateRange = {
      capturedDateRange: {
        startDate: dateRangeSelections[dataKey].startDate,
        endDate: dateRangeSelections[dataKey].endDate,
      },
    }
    this.setState({ ...this.initialModalState, selectedDateRange }, () => this.loadProfileData())
  }

  handleDateRangeCancel = () => this.setState({ ...this.initialModalState, step: "docSelection" })

  handleInvalidDateRangeSave = () => {
    this.setState({ dateSelectionRangeExceeded: true, step: "docSelection" }, () =>
      this.displayWarning({ code: "DateRangeInvalid" }),
    )
  }

  handleWarningModalOnClick = () => {
    if (this.state.dateSelectionRangeExceeded) {
      this.setState({ warningModalOpen: false })
      return
    }
    this.closeModals()
  }

  displayWarning(error: any) {
    let header = "Warning"
    let warning = ""

    try {
      if (error.code === "NetworkError") {
        warning = "Seems like your internet connection is down. Reconnect to the network, then try again."
      } else if (error.code === "NoDocumentSelected") {
        header = "Select a document"
        warning = "Select a document"
      } else if (error.code === "NoFolders") {
        header = "None selected"
        warning = "Select at least one type of document to continue."
      } else if (error.code === "NoDocs") {
        header = "No docs"
        warning = "There are no documents that meet your filter criteria"
      } else if (error.code === "DateRangeInvalid") {
        header = "Date selection range invalid"
        warning = "Ensure date selections are valid and inside maximum date range"
      } else if (error.code === "DateRangeExceed") {
        header = "Date range exceeded"
        warning = "The maximum date range is 1 month"
      } else if (error.code === "DownloadInProgress") {
        header = "Donwload in progress"
        warning = "There is already a download in progress. Wait for it to finish then try again."
      } else if ("message" in error) {
        warning =
          "The following error message was returned when logging in:\n\n'" +
          error.message +
          "'. \n\nRefresh the page and try again. If unsuccessful, then contact tech support"
      } else {
        warning = "We encountered a problem. Refresh the page and try again. If unsuccessful, then contact tech support"
      }
    } catch (error) {
      warning = "We encountered a problem. Refresh the page and try again. If unsuccessful, then contact tech support"
    }
    this.setState({
      ...this.initialModalState,
      warningModalOpen: true,
      warningModalHeader: header,
      warningModalMessage: warning,
    })
  }

  render() {
    const columnConfig = this.generateToolbarConfig()
    const {
      customProfileFilterConfig,
      docTableConfig,
      docDateRangesModalOpen,
      downloadQueueModalOpen,
      isUpdatingDocExportQueue,
      itemsDownloading = [],
      profileData,
      sectionConfig,
      selectedCategoryName,
      selectedDateRange,
      selectedFolders,
      step,
      selectAllEnabled,
      tableWidth,
      loadingModalMessage,
      loadingModalAuxMessage,
    } = this.state

    const { asyncTaskQueueDocExport = [], navMenuAccess, itemsBeingGenerated = [] } = this.props
    const { hasDocExportAccess } = navMenuAccess

    let table = null
    if (step === "docSelection") {
      table = (
        <DocSelection
          columnConfig={columnConfig as DocTableColumnConfig}
          docTableConfig={docTableConfig}
          sectionConfig={sectionConfig}
          selectedCategoryName={selectedCategoryName}
          selectedFolders={selectedFolders}
          onSectionClick={(section: string) => this.loadSection(section)}
          onFolderSelection={(folder: string) => this.folderSelectionHandler(folder)}
          onSelectAllDocs={(selectAllState: boolean) => this.onSelectAllDocs(selectAllState)}
          onToolbarClicked={(buttonId: string) => this.docToolbarHandler(buttonId)}
        />
      )
    }
    if (step === "profileSelection") {
      const tableRowData = tableService.applySearch(this.state.searchString, profileData)
      const tableColumnDef = tableService.convertPfColumnConfigToGridColDef(columnConfig)
      table = (
        <Table
          rows={tableRowData}
          columns={tableColumnDef}
          tableHeight={tableHeight}
          rowSelection={true}
          onRowSelection={(selectedRowIds: string[]) => this.setState({ selectedProfilePks: selectedRowIds })}
          key={`profileSelectionTable_${selectedCategoryName}`}
        />
      )
    }

    let tableNavButtons = [
      {
        label: "VIEW QUEUE",
        iconPath: mdiPlaylistPlus,
        onClick: () => this.updateQueueData(true),
      },
    ]
    if (step === "docSelection") {
      tableNavButtons.push({
        label: `${selectAllEnabled ? "DESELECT ALL" : "SELECT ALL"}`,
        iconPath: selectAllEnabled ? mdiCircleMultiple : mdiCircleMultipleOutline,
        onClick: () => this.docToolbarHandler("selectAll"),
      })
    }
    if (step === "profileSelection") {
      tableNavButtons.push({
        label: "GENERATE",
        iconPath: mdiFilePlus,
        onClick: () => this.generateDocs(),
      })
    }

    let docDateRangesModal = null
    if (docDateRangesModalOpen) {
      const MS_THIRTY_DAYS = 2592000000
      const config = [
        {
          label: "Captured On",
          defaultStartDateMs: new Date().getTime() - MS_THIRTY_DAYS,
          maxRangeExceededMessage: "The maximum selection date range is 1 month",
        },
      ]
      docDateRangesModal = (
        <DateRangesModal
          title="Date Filter"
          dateRangeConfig={config}
          open={true}
          onCancelClick={this.handleDateRangeCancel}
          onSaveClick={(dateRangeSelections) => this.handleDateRangeSave(dateRangeSelections, config[0].label)}
          onInvalidDateRangeSave={this.handleInvalidDateRangeSave}
        />
      )
    }

    let downloadQueueModal = null
    if (downloadQueueModalOpen) {
      downloadQueueModal = (
        <DownloadQueueModal
          open={downloadQueueModalOpen}
          downloadQueue={DocsService.asyncTasksToDownloadQueueItems(asyncTaskQueueDocExport)}
          itemsDownloading={itemsDownloading}
          itemsBeingGenerated={itemsBeingGenerated}
          header={"Download Queue"}
          body={""}
          isUpdatingDocExportQueue={isUpdatingDocExportQueue}
          updateQueueData={() => this.updateQueueData()}
          download={(filePath: string, queueId: string) => this.downloadFile(filePath, queueId)}
          dismiss={() => this.closeModals()}
        />
      )
    }

    return (
      <div style={styles.container}>
        <NavBar match={this.props.match} location={this.props.location} history={this.props.history} />

        <SectionHeader
          style={styles.sectionHeader}
          disabled={step === "docSelection"}
          downloading={this.state.downloading}
          searchString={this.state.searchString}
          textHandler={(e) => this.searchHandler(e)}
          onClick={() => ({})}>
          {this.props.currentScreen}
        </SectionHeader>

        <div style={{ ...styles.rightSide, paddingInline: "min(5em, 5%)" }}>
          <Toolbar
            actionButtons={tableNavButtons}
            navButtons={{
              left:
                step === "profileSelection" ? { onClick: () => this.setState({ step: "docSelection" }) } : undefined,
              right:
                step === "docSelection"
                  ? { onClick: () => this.setState({ step: "profileSelection", docDateRangesModalOpen: true }) }
                  : undefined,
            }}
          />
          <div style={styles.rightSideContent}>{table}</div>
        </div>

        {docDateRangesModal}
        {downloadQueueModal}
        <AlertModalOneButton
          open={this.state.warningModalOpen}
          header={this.state.warningModalHeader}
          body={this.state.warningModalMessage}
          buttonLabel={"Ok"}
          onClick={this.handleWarningModalOnClick}
        />
        <AlertModalOneButton
          // TODO: There should only be one AlertModalOneButton component per screen with the required headers, body, and functions being set accordingly by a handler.
          open={!hasDocExportAccess}
          header={"Not Authorised"}
          body={"You don't have permission to export documents."}
          buttonLabel={"Ok"}
          opaqueBackground={true}
          onClick={() => this.props.history.goBack()}
        />
        <LoadingModal
          open={this.state.loadingModalOpen}
          loadingMessage={loadingModalMessage}
          auxilliaryMessage={loadingModalAuxMessage}
        />
      </div>
    )
  }
}

const styles = {
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column" as "column",
    backgroundImage: `linear-gradient(to bottom, ${ColorPalette.SCREEN_TOP_GRADIENT}, ${ColorPalette.SCREEN_BOTTOM_GRADIENT})`,
    height: "100vh",
  },
  sectionHeader: {
    margin: "3.5% auto 1.5%",
  },
  contentContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
  },
  rightSide: {
    display: "flex",
    flexDirection: "column" as "column",
    paddingInline: "max(2em, 2%)",
    overflow: "hidden",
  },
  rightSideContent: {
    boxShadow: "0px -1px 8px rgba(60,60,60, 0.1)",
    display: "flex",
    flex: 1,
    backgroundColor: ColorPalette.CARD_WHITE,
  },
  buttonIconStyle: {
    color: ColorPalette.PRIMARY_TEXT,
    width: "1.2rem",
    height: "1.2rem",
  },
  toolbarButton: {
    marginTop: window.innerHeight * 0,
    fontWeight: "bolder" as "bolder",
    fontSize: "0.8rem",
    color: ColorPalette.SECONDARY_TEXT,
    height: 40,
    ":hover": {
      color: ColorPalette.PRIMARY_BLUE,
    },
    ":active": {
      color: ColorPalette.DARK_GREY,
    },
  },
  tableNavButtonContainer: {
    display: "flex",
    alignItems: "center",
    width: (window.innerWidth * 10) / 12,
  },
  downloadButtonContainer: {
    marginRight: 10,
  },
  additionalInfo: {},
}

const mapStateToProps = (state: PeopleFlowCombinedReducer) => {
  return {
    idPassport: state.sessionManager.idPassport,
    password: state.sessionManager.password,
    associationRepo: state.sessionManager.associationRepo as AssociationSettingsRepository,
    userRepo: state.sessionManager.userRepo as UsersRepository,
    profileRepo: state.sessionManager.profileRepo as ProfileRepository,
    selectedCohort: state.sessionManager.selectedCohort,
    selectedAssociation: state.sessionManager.selectedAssociation,
    currentSection: state.sessionManager.currentSection,
    currentScreen: state.sessionManager.currentScreen,
    profile: state.sessionManager.profile,
    navMenuAccess: state.sessionManager.navMenuAccess,
    asyncTaskQueueDocExport: state.sessionManager.asyncTaskQueueDocExport,
    itemsBeingGenerated: state.sessionManager.itemsBeingGenerated,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateState: (data: any) => dispatch({ type: ActionType.UPDATE_STATE, data }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Radium(DocExports))
